module.exports = __webpack_public_path__ + "static/media/towardsLeft.e28301b7.svg";